// extracted by mini-css-extract-plugin
export default {"method-modal":"style_method-modal__oPeYA","methodModal":"style_method-modal__oPeYA"};